import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
import { matchPath } from "react-router-dom";

function hideHeader(url: string): boolean {
  return !!matchPath("/stores/:storeId/customer-portal-builder", url);
}

function hideNavbar(url: string): boolean {
  return hideHeader(url);
}

function hidePadding(): boolean {
  return true;
}

export const customerPortalBuilderRoutes: PermissionedRouteObject[] = [
  {
    handle: { breadcrumb: "Portal Builder" },
    async lazy() {
      const { Page } = await import("../../page");
      return {
        element: (
          <Page
            hideHeader={hideHeader}
            hideNavbar={hideNavbar}
            hidePadding={hidePadding}
          />
        ),
      };
    },
    children: [
      {
        index: true,
        lazy: async () => {
          const { CustomerPortalBuilderPage } = await import(
            "@redotech/redo-merchant-general-app/customer-portal-builder/customer-portal-builder"
          );
          return { Component: CustomerPortalBuilderPage };
        },
      },
    ],
  },
];
